import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, Stack, Grid } from '@mui/material';
import React, { useState } from 'react';
import PersonnelService from '../../services/PersonnelService';
import { useNavigate } from 'react-router';
import { LoadingButton } from '@mui/lab';
import Spacer from '../../components/Spacer';
import Message from './Message';


const CardOption = ({ value, selectedValue, onChange, label, children }) => {
  const isSelected = selectedValue === value;
  return (
     <Box
      onClick={() => onChange(value)}
      sx={{
        border: isSelected ? "2px solid #1976d2" : "1px solid lightgray",
        borderRadius: 2,
        p: 2,
        cursor: "pointer",
        textAlign: "center",
        fontWeight: "bold",
        transition: "border-color .15s ease",
        userSelect: "none",
        width: "100%" ,
        height: "380px",

      }}
    >
      <Radio
        checked={isSelected}
        value={value}
        onClick={(e) => e.stopPropagation()}
        onChange={() => onChange(value)}
      />
      <div style={{ margin: "0 auto" }}>{children}</div>
      <div style={{ marginTop: 8 }}>{label}</div>
    </Box>
  );
};

const CardSkeleton = ({ width, height, spacing = 2 }) => {
  return (
    <div
      style={{
        width,
        height,
        border: "1px solid lightgray",
        borderRadius: "8px",
        margin: "0 auto",
      }}
    >
      <Grid container spacing={1} style={{ marginTop: spacing }}>
        {/* Header 2 colonnes */}
        <Grid container item xs={6} borderRight={1}>
          <div
            style={{
              width: width * 0.33,
              height: height * 0.07,
              backgroundColor: "#9291912d",
              margin: "0 auto",
            }}
          />
        </Grid>
        <Grid container item xs={6}>
          <div
            style={{
              width: width * 0.33,
              height: height * 0.07,
              backgroundColor: "#9291912d",
              margin: "0 auto",
            }}
          />
        </Grid>

        {/* Avatar central */}
        <Grid item xs={12}>
          <div
            style={{
              width: width * 0.33,
              height: height * 0.23,
              backgroundColor: "#9291912d",
              margin: "16px auto",
            }}
          />
        </Grid>

        {/* Trois lignes */}
        {[0.25, 0.35, 0.25].map((ratio, i) => (
          <Grid key={i} item xs={12}>
            <div
              style={{
                width: width * ratio,
                height: 5,
                backgroundColor: "#9291912d",
                margin: " auto",
              }}
            />
          </Grid>
        ))}

        {/* Footer 2 colonnes */}
        <Grid container item xs={6}>
          <div
            style={{
              width: width * 0.3,
              height: height * 0.15,
              backgroundColor: "#9291912d",
              margin: "8px auto",
            }}
          />
        </Grid>
        <Grid container item xs={6}>
          <div
            style={{
              width: width * 0.3,
              height: height * 0.15,
              backgroundColor: "#9291912d",
              margin: "8px auto",
              borderTopLeftRadius: "100px",
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const ExportBadge = (props) => {
    const { dialogExportBadge } = props;
    const { open, onClose, selectedUsers, id_user } = dialogExportBadge;
    const [sizeSelected, setSizeSelected] = useState("L");
    const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState({
        openMessage: false,
        color: 'green',
        messageInfo: '',
      });
      const { openMessage, color, messageInfo } = message;
    const navigate = useNavigate();
      function handleCloseMessage(){
      setMessage({...message, openMessage: false});
  }

    const downloadFile = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

     function generateUserBadge() {
        setLoading(true);
        PersonnelService.generateBadgePdf(id_user, sizeSelected).then((response) => {
          const blob = new Blob(
            [response.data || response], 
            { type: 'application/pdf' }
          );
          const fileName = `Badge_${id_user}.pdf`;
          downloadFile(blob, fileName);
          setMessage({
            openMessage: true,
            color: 'green',
            messageInfo: 'Badge généré avec succès',
          });
        })
          .catch((error) => {
            console.error('Erreur lors du téléchargement du PDF :', error);
          })
          .finally(() => {
            onClose();
            setLoading(false);
          });
      }

      async function handleExportUsersBadges() { // generate badges for selected users
      
          setLoading(true)
          PersonnelService.getBagdeUsers(selectedUsers, sizeSelected)
          .then((response) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            
            a.style.display = 'none';
            a.href = url;
            a.download = `Badges.pdf`; 
        
            document.body.appendChild(a);
            a.click(); 
            window.URL.revokeObjectURL(url); 
            setMessage({
              openMessage: true,
              color: 'green',
              messageInfo: 'Badges générés avec succès',
            });
            onClose();
            navigate("/annuaire");
      
          })
          .catch((err) => { 
            console.error("Une erreur lors de la génération des badges", err);
          })
          .finally(() => {
            setLoading(false)
          });
        }
      
  return (
    <>
          <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
          {/* Dialog pour la confirmation generation badge */}
        <Dialog
          open={open}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle id="form-dialog-title" style={{ color: "white" }} >
            {"Géneration badge"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Spacer y={2}/>
              {
                "Veuillez sélectionner la taille du badge avant de le générer."
              }
                <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={4}              
              sx={{ mt: 1, alignItems: "flex-start" }}
            >
                  <CardOption
                    value="L"
                    selectedValue={sizeSelected}
                    onChange={setSizeSelected}
                    label="12 cm * 9 cm"
                  >
                    <CardSkeleton width={180} height={260} />
                  </CardOption>

                  <CardOption
                    value="S"
                    selectedValue={sizeSelected}
                    onChange={setSizeSelected}
                    label="8.5 cm * 5.4 cm"
                  >
                    <CardSkeleton width={130} height={230} spacing={0.5} />
                  </CardOption>
                </Stack>
            
            </DialogContentText>
          </DialogContent>
          <DialogActions >
            <Button color="primary" component="span" onClick={onClose}>
              Annuler
            </Button>
            <LoadingButton variant="contained" color="primary"  autoFocus loading={loading} 
            onClick={ () => {id_user ? generateUserBadge() : selectedUsers.length > 0 ? handleExportUsersBadges() : alert("Aucun utilisateur sélectionné")}}>
              Générer
            </LoadingButton>
          </DialogActions>
        </Dialog>
    </>
  );
};

export default ExportBadge;